import React from 'react'
import style from './Header.module.css'
import Logo from '../Logo/Logo'
import classNames from 'classnames'
import { useDispatch } from 'react-redux'
import { logout } from '../../store/actions'
import { Button, ButtonTheme } from '@dbrainio/shared-ui'
import Container from '@mui/material/Container'
import Grid from '@mui/material/Grid'
import { useNavigate } from 'react-router-dom'

interface HeaderProps {
  transparent?: boolean
  isLoggedIn?: boolean
}

export default function Header({ transparent, isLoggedIn }: HeaderProps) {
  const navigate = useNavigate()

  const dispatch = useDispatch()

  const renderLogo = () => (
    <div onClick={() => navigate('/')} className={style.logo}>
      <Logo />
    </div>
  )

  const handleLogout = () => {
    dispatch(logout())
  }

  const renderLogout = () => (
    <Button onClick={handleLogout} theme={ButtonTheme.WhiteLink}>
      Log out
    </Button>
  )

  return (
    <div className={classNames(style.root, transparent && style.transparent)}>
      {transparent ? (
        renderLogo()
      ) : (
        <Container>
          <Grid container justifyContent="space-between" alignItems="center">
            {renderLogo()}
            {isLoggedIn && renderLogout()}
          </Grid>
        </Container>
      )}
    </div>
  )
}
